import Vue from 'vue'
import VueRouter from 'vue-router'

// Main pages
import Home from './pages/Home'
import Start from './pages/Start'
import GameSelect from './pages/GameSelect'
import Hengelen from './pages/Hengelen'
import Golven from './pages/Golven'

import Preload from './pages/Preload'

Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/',
  //   redirect:
  //   {
  //     name: 'Home'
  //   }
  // },
  {
    path: '/home',
    name: 'Home',
    component: Home
  },
  {
    path: '/start',
    name: 'Start',
    component: Start
  },
  {
    path: '/game_select',
    name: 'GameSelect',
    component: GameSelect
  },
  {
    path: '/hengelen',
    name: 'Hengelen',
    component: Hengelen
  },
  {
    path: '/golven',
    name: 'Golven',
    component: Golven
  },
  {
    path: '/preload',
    name: 'Preload',
    component: Preload
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
